module.exports = __webpack_public_path__ + "static/personal_resources-08f4b8ef5501cbfdd673a42c22f84320.jpg";